import type {
    DashboardVisualizationsWithoutExpandedExecution,
    GetDashboardResponse,
} from '@blockworks/platform/api/research/studio';
import { studioExecutionApi } from '@blockworks/platform/api/research/studio';

import { getTableVisualizationPageSize } from '../../visualization';
import { PreloadedDashboardData } from '../dashboard-grid.model';

import { getPreloadableVisualizations } from './get-preloadable-visualizations';

/**
 * Prepares `preloadedData` for a public `DashboardGrid`.
 */

const fetchPreloadedDashboardData = async (
    /** Required dashboard data to prepare `preloadedData` for. */
    dashboard: GetDashboardResponse['data'],
): Promise<{
    preloadedData: PreloadedDashboardData;
    visualizations: DashboardVisualizationsWithoutExpandedExecution;
}> => {
    const topVisualizations = getPreloadableVisualizations(dashboard);
    const preloadedData: PreloadedDashboardData = [];

    for (const visualization of topVisualizations) {
        const { data } = await studioExecutionApi.useGetExecution.fetcher({
            id: visualization.lastExecutionId,
            limit: getTableVisualizationPageSize(visualization.config),
        });

        preloadedData.push({ ...visualization, execution: data });
    }

    const visualizations = dashboard.visualizations.map(visualization => {
        if (topVisualizations.some(topViz => topViz.id === visualization.id) || dashboard.isPublic) {
            return visualization;
        }
        const { lastExecutionId, ...nonDiscoverableAttrs } = visualization;
        return nonDiscoverableAttrs;
    });

    return { preloadedData, visualizations };
};

export { fetchPreloadedDashboardData };
